import { getIsCashJourneySelected } from "@shared/v2/lib/getIsCashJourneySelected";
import { getIsLLDJourneySelected } from "@shared/v2/lib/getIsLLDJourneySelected";

import { getFormattedPrice } from "@shared/v2/lib/getFormattedPrice";

export class Deal {
  constructor(deal, appConfig) {
    this._deal = deal;
    this.currency =
      deal.currentDeal?.configuration?.app.solJourney.currency ??
      appConfig.configuration.app.solJourney.currency;
  }

  get isCashJourneySelected() {
    return getIsCashJourneySelected(this._deal.financeSimulation.journey);
  }

  get isLLDJourneySelected() {
    return getIsLLDJourneySelected(this._deal.financeSimulation.journey);
  }

  get defaultCashPrice() {
    return getFormattedPrice(
      this._deal.financeSimulation.defaultPrice.cash.netPrice,
      this.currency.format,
      this.currency.symbol
    );
  }

  get preconfiguration() {
    return this._deal.carConfiguration.preconfiguration;
  }

  get accessory() {
    return this._deal.carConfiguration.accessory[0] ?? null;
  }

  get service() {
    return this._deal.carConfiguration.service[0] ?? null;
  }

  get packs() {
    return this._deal.carConfiguration.options;
  }
}
